/* @flow */

import { getLocalizedData } from '@e180/domain/lib/base/l10n/util';
import { getEventPlugins } from '@e180/domain/lib/event/util';
import { assertObject } from '@e180/util/lib/assert';
import { isObject } from '@e180/util/lib/type';

import { onboardingCustomTextPlugin } from 'src/shared/app/feature/settings/featureSettings';

import type { BraindateEvent } from '@e180/domain/lib/event/type';

export function getOnboardingCustomTextOptions(event: BraindateEvent): ?Object {
  const options = getEventPlugins(event)[onboardingCustomTextPlugin];

  if (options) {
    assertObject(options, 'options');

    return options;
  }
}

export function getOnboardingCustomTextLocalizedData(
  event: BraindateEvent,
  locale?: string,
): ?Object {
  const body = (getOnboardingCustomTextOptions(event) || {}).custom_copy;

  if (isObject(body)) {
    return getLocalizedData(body, locale);
  }
}

export function getOnboardingCustomTitle(
  event: BraindateEvent,
  locale?: string,
): string {
  return (
    (getOnboardingCustomTextLocalizedData(event, locale) || {}).title || ''
  );
}

export function getOnboardingCustomSubtitle(
  event: BraindateEvent,
  locale?: string,
): string {
  return (
    (getOnboardingCustomTextLocalizedData(event, locale) || {}).subtitle || ''
  );
}

export function getOnboardingCustomCTA(
  event: BraindateEvent,
  locale?: string,
): string {
  return (getOnboardingCustomTextLocalizedData(event, locale) || {}).cta || '';
}
